var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-inclusion-status button"},[(_vm.isInMyNetwork)?_c('div'):_c('div',[_c('common-button',{attrs:{"label":_vm.$t('elements.network.network_inclusion_status.buttons.add_to_my_network'),"isSubmittable":false,"size":'micro',"type":"add-to-my-network"},on:{"click":_vm.addToNetworkClicked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }